import TagStatus from '@/app/shared_components/tags/TagStatus.vue';
import TagCount from '@/app/shared_components/tags/TagCount.vue';
import TagStatusCircle from '@/app/shared_components/tags/TagStatusCircle.vue';

export default {
  install(app) {
    app.component('TagStatus', TagStatus);
    app.component('TagStatusCircle', TagStatusCircle);
    app.component('TagCount', TagCount);
  },
};
